const getUserPreferredLlmProvider = (rawPreferences: unknown): string => {
  try {
    const parsed = typeof rawPreferences === "string" ? JSON.parse(rawPreferences) : rawPreferences;

    const rawPref =
      parsed && typeof parsed === "object" && "preferredLlmProvider" in parsed
        ? (parsed as Record<string, unknown>).preferredLlmProvider
        : null;

    const pref = typeof rawPref === "string" ? rawPref.toLowerCase() : "";

    return pref === "mistral" ? "mistral" : "openai";
  } catch {
    return "openai";
  }
};

export default getUserPreferredLlmProvider;
